export default __webpack_public_path__ + "static/media/ellipse-separator.be8957b7.svg";